export class Article {
  id: string;
  title: string;
  isSelected: boolean;
  published: boolean;
  mainPage: boolean;
  document: string;
}
